/*
* frankenMenu v1.0 // Karmabunny Web Design // built by Luke Underwood
*/

;$(function() {

    var frankenMenu = $.fn.frankenMenu = function(options) {

        var $this = $(this);
        var opts = $.extend( {}, $.fn.frankenMenu.defaults, options );
        var menuVersion = '';
        var $html = $("html");
        var $navList = $("#frankenmenu-list");


        // Handles console logs
        var frankenLog = function(output, type) {
            if(type === "error") {
                var bg = "#ffc1c1",
                color = "#660202",
                type = "ERROR";
            } else if(type === "warning") {
                var bg = "#fffca5",
                color = "#666302",
                type = "WARNING";
            }
            console.log('%cFrankenMenu ' + type + ': ' + output, 'background: ' + bg + '; color: ' + color + '; padding: 0 2px;');
        }

        // Add class so we know megamenu is active
        if(opts.megaMenu){
            $html.addClass("frankenmenu-mega");
        }

        // Add class for menu btn text
        if(opts.mobileMenuText){
            $html.addClass("frankenmenu-button-text");
        }

        // Alert if devMode active
        if(opts.devMode) {
            frankenLog("FrankenMenu developer mode is active. Ensure this is turned off on the live site", "warning");
        }

        var hideTimeout = 0;
        var hasFocus = null;

        var show = function($target) {
            hasFocus = $target[0];
            clearTimeout(hideTimeout);
            $target.addClass('frankenhover');

            onShowItem($target);
            onShowGlobal();
        }

        var hide = function($target) {
            hasFocus = null;
            $target.removeClass('frankenhover');

            // Call the hide hook, but only if we haven't toggled some
            // other menu item.
            clearTimeout(hideTimeout);
            hideTimeout = setTimeout(function() {
                onHideGlobal();
            }, 100);
        }

        // Initialise Desktop menu
        var initDesktopMenu = function() {
            var toggleTimeout = 0;

            // Clear the focus when returning to a page.
            window.addEventListener('focus', function() {
                if ($navList[0].contains(document.activeElement)) {
                    document.documentElement.focus();
                }
            });

            $navList.children().each(function() {
                var $this = $(this);
                $this.attr('tabindex', 0);

                // Initial click.
                $this.on('focusin', function(event) {
                    show($this);

                    // Prevent clicks for a bit so we can do toggle things.
                    clearTimeout(toggleTimeout);
                    toggleTimeout = setTimeout(function() {
                        toggleTimeout = 0;
                    }, 350);
                });

                // Toggle clicks.
                $this.on('click', function(event) {
                    if (toggleTimeout) return;

                    if (hasFocus === $this[0]) {
                        hide($this);
                    }
                    else {
                        show($this);
                    }
                });

                // Click out.
                $this.on('focusout', function(event) {
                    hide($this);
                });
            });

            if(opts.devMode) {
                // Dev mode to force show/hide submenus/megamenus
                $(window).keypress(function(e) {
                    if(e.which === 104) {
                        $(".frankenhover").addClass("frankenhold");
                    } else if(e.which === 114) {
                        $(".frankenhold").removeClass("frankenhold");
                    }
                });
            }

            menuVersion = "desktop";

        }

        // Initialise the menu, depending on which type
        var frankenMenuInit = function() {

            if (window.innerWidth > opts.menuBreakpoint && menuVersion !== "desktop") {

                initDesktopMenu();

            }
        }

        var onShowItem = function($target) {
            setTimeout(function(){
                if($target.offset().left+$target.width() > window.innerWidth){
                    $target.addClass('submenu-right-align');
                }
            }, 10);
        }

        var onShowGlobal = function() {
            document.documentElement.classList.add('menu-open');
        }

        var onHideGlobal = function() {
            document.documentElement.classList.remove('menu-open');
        }

        $(window).on('load resize', function () {
            frankenMenuInit();
        });

        frankenMenuInit();
    }


    // Default options
    $.fn.frankenMenu.defaults = {
        menuBreakpoint: 600,
        devMode: false,

        // Desktop Menu Options
        megaMenu: false,
        desktopAnimationIn: {
            opacity: "show"
        },
        desktopAnimationOut: {
            opacity: "hide"
        },
        desktopTransitionSpeedIn: 300,
        desktopTransitionSpeedOut: 200,

        // Mobile Menu Options
        mobileMenuText: false,
        mobileMenuPosition: "right",
        mobileTransitionSpeedIn: 300,
        mobileTransitionSpeedOut: 300,
    }

});

